/* online co-op — thin relay client for night rooms. The host device runs the real
   night engine and streams state snapshots; the guest streams its pad back and
   renders the host's night. The server only shuttles messages between the pair. */

export function connectNightRoom(code, role, handlers) {
  const base = process.env.REACT_APP_BACKEND_URL.replace(/^http/, "ws");
  const ws = new WebSocket(`${base}/api/ws/night/${code}?role=${role}`);
  ws.onopen = () => handlers.onOpen?.();
  ws.onmessage = (e) => {
    let msg;
    try {
      msg = JSON.parse(e.data);
    } catch {
      return;
    }
    handlers.onMessage?.(msg);
  };
  ws.onclose = () => handlers.onClose?.();
  ws.onerror = () => handlers.onError?.();
  return {
    send: (msg) => {
      if (ws.readyState === 1) ws.send(JSON.stringify(msg));
    },
    close: () => {
      try {
        ws.close();
      } catch {
        /* already gone */
      }
    },
  };
}

/* render smoothing — the guest renders one snapshot interval behind and lerps
   positions between the last two snapshots so motion stays fluid at ~20Hz */
export function lerpNight(a, b, t) {
  if (!a || !b) return b || a;
  const L = (x, y) => x + (y - x) * t;
  const g = { ...b };
  g.runners = (b.runners || []).map((r, i) => {
    const o = (a.runners || []).find((p) => p.id === r.id) || (a.runners || [])[i];
    return o ? { ...r, x: L(o.x, r.x), y: L(o.y, r.y) } : r;
  });
  for (const key of ["zombies", "dogs"]) {
    g[key] = (b[key] || []).map((z, i) => {
      const o = (a[key] || [])[i];
      return o ? { ...z, x: L(o.x, z.x), y: L(o.y, z.y) } : z;
    });
  }
  return g;
}
